// `/admin/reconciliation/runs/$id`, o drawer `ExecucaoConciliacao` do croqui. É só o
// CONTEÚDO: o `Drawer`, o título e o botão de fechar vêm do `RouteDrawer` da rota-pai
// (`admin.reconciliation.tsx`), que segue desenhando a tela embaixo.
//
// Sem step-up nesta tela: ler o relatório não é ação sensível, o único botão que exige
// segundo fator é o de destravar saque, e ele vive na tabela "Divergências abertas" da
// página, não aqui (é assim no croqui).

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { RunDetailPanel } from '../features/admin-reconciliation/run-detail.tsx';

function ReconciliationRun() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  return (
    <RunDetailPanel
      id={id}
      onClose={() => {
        void navigate({ to: '/admin/reconciliation', search: (prev) => prev });
      }}
    />
  );
}

export const Route = createFileRoute('/admin/reconciliation/runs/$id')({
  component: ReconciliationRun,
});
